import { ApiService } from "../api.service";

export class AppShareNewService {

  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  //获取分享数据
  getShareData(learningPathMetaId){
    return this.apiService.ajax({
      'type':'GET',
      'url':'/sr/getShareData/'+learningPathMetaId
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-share/app-share-new.service.ts